module.exports = __webpack_public_path__ + "img/icon-hamburger-button.3e08dcb3.svg";